import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c143067&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c143067')) {
      api.createRecord('6c143067', component.options)
    } else {
      api.reload('6c143067', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6c143067&", function () {
      api.rerender('6c143067', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/base-form/index.vue"
export default component.exports